import { __extends } from "tslib";
import { ProductDirectiveBaseController } from '../common/models/product-directive-base.controller';
import { fetchImages } from './utilities/fetch-images';
var ProductImagesDirectiveController = /** @class */ (function (_super) {
    __extends(ProductImagesDirectiveController, _super);
    function ProductImagesDirectiveController($scope, $transclude, $element, $q) {
        var _this = _super.call(this, $scope, $transclude, $element) || this;
        _this.$scope = $scope;
        _this.$transclude = $transclude;
        _this.$element = $element;
        _this.$q = $q;
        return _this;
    }
    ProductImagesDirectiveController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    ProductImagesDirectiveController.prototype.updateFromProduct = function (productId) {
        var _this = this;
        this.transclude();
        this.$q.when(fetchImages(productId, this.$scope.pType))
            .then(function (images) {
            _this.$scope.images = images || [];
        });
    };
    ProductImagesDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductImagesDirectiveController;
}(ProductDirectiveBaseController));
export var ProductImagesDirective = [
    function () {
        return {
            controller: ProductImagesDirectiveController,
            restrict: 'E',
            scope: {
                pId: '<',
                pType: '@',
            },
            transclude: true,
        };
    },
];
